import { type RefObject, useEffect } from "react";
import { useStepStore } from "@/store";

export const useWidgetBlock = (ref: RefObject<HTMLDivElement | null>) => {
  const { isWidgetBlocked } = useStepStore();

  useEffect(() => {
    if (!ref.current) return;
    ref.current.style.pointerEvents = isWidgetBlocked ? "none" : "";
    ref.current.style.userSelect = isWidgetBlocked ? "none" : "";
  }, [isWidgetBlocked, ref]);
};